<template>
  <div class="tabsBox">
    <el-tabs :tab-position="tabPosition">
      <el-tab-pane :label="$t('ability3.tab1')"
        ><div class="main-ability3">
          <div class="left-box">
            <div class="ability3-left">
              <div class="mask-1">
                <img src="../assets/img/信用中国/信用中国2.png" alt="" />
              </div>
              <div class="mask-2">
                <img :src="$i18n.locale === 'zh' ? require('../assets/img/信用中国/信用中国1.png') : require('../assets/img/信用中国/信用中国1-英.png')" alt="" />
              </div>
            </div>
          </div>
          <div class="right-box">
            <h3 v-if="$i18n.locale === 'zh'">{{ $t('ability3.tab1Title') }}</h3>
            <h4 v-if="$i18n.locale === 'en'" style="text-align: left; margin-top: 0">{{ $t('ability3.tab1Title') }}</h4>
            <div class="right-desc">
              <div class="red-box">
                <span class="red-font">{{ $t('ability3.tab1Original') }}</span>
                <span class="hui-font">{{ $t('ability3.tab1Column') }}</span>
              </div>
              <div class="hui-time">{{ $t('ability3.tab1Date') }}</div>
            </div>
            <p class="font-desc">
              {{ $t('ability3.tab1Desc') }}
            </p>
            <div class="bgc-hui">
              <div class="red-animation"></div>
            </div>
            <div class="red-href">
              <a
                href="https://mp.weixin.qq.com/s/iIDZxcRRNCLXq8Zlw5DhLQ"
                target="_blank"
                >{{ $t('ability3.tab1Link') }}</a
              >
            </div>
          </div>
        </div></el-tab-pane
      >
      <el-tab-pane :label="$t('ability3.tab2')"
        ><div class="main-ability3">
          <div class="left-box" style="margin-top: -20px">
            <div class="ability3-left">
              <div class="mask-1">
                <img src="../assets/img/信用中国/聘书1.png" alt="" />
              </div>
            </div>
          </div>
          <div class="right-box">
            <h3 v-if="$i18n.locale === 'zh'">{{ $t('ability3.tab2Title') }}</h3>
            <h4 v-if="$i18n.locale === 'en'" style="text-align: left; margin-top: -5px">{{ $t('ability3.tab2Title') }}</h4>
            <div class="right-desc"></div>
            <p class="font-desc">
              {{ $t('ability3.tab2Desc') }}
            </p>
            <div class="bgc-hui">
              <div class="red-animation"></div>
            </div>
          </div></div
      ></el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  name: "Ability3",
  tabPosition: "left",
};
</script>

<style scoped lang="scss">
::v-deep .el-tabs__item {
  color: red;
}
::v-deep .el-tabs__item.is-active {
  color: red;
  font-weight: bold;
}
::v-deep .el-tabs__active-bar {
  background-color: red;
}
.tabsBox {
  max-width: 1150px;
  width: 100%;
  padding: 0 20px;
  height: auto;
  min-height: 350px;
  margin: 0 auto;
  .lang-en & {
    min-height: 450px;
  }
  @media (max-width: 768px) {
    flex-direction: column;
    width: 100%;
    height: auto;
    min-height: 600px;
  }
}
.main-ability3 {
  max-width: 1150px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
  margin-bottom: 5px;

  // Medium screen: allow flexible widths before wrapping
  @media (max-width: 1100px) {
    .ability3-left {
      width: 44%;
      min-width: 280px;
    }
    .right-box {
      width: 52%;
      min-width: 300px;
    }
  }

  // Tablet: stack when too narrow for side-by-side
  @media (max-width: 768px) {
    flex-direction: column;
    width: 100%;
  }

  .ability3-left {
    position: relative;
    width: 500px;
    overflow: hidden;

    &:hover {
      .mask-1 {
        transform: scale(1.1);
        transition: 0.5s all;
      }
    }

    img {
      width: 100%;
      height: 100%;
      opacity: 0.9;
    }

    .mask-1 {
      transition: 0.5s all;
    }

    .mask-2 {
      position: absolute;
      top: 0;
      left: 0;
      height: 275px;

      @media (max-width: 768px) {
        height: 100%;
      }
    }

    @media (max-width: 768px) {
      width: 100%;

      .mask-1 {
        transform: none;
      }
    }
  }

  .right-box {
    width: 570px;
    position: relative;

    &:hover {
      .bgc-hui .red-animation {
        width: 100%;
      }
    }

    @media (max-width: 768px) {
      width: 100%;
      padding: 10px;
    }

    h3 {
      margin-top: 0;
      padding-top: 0;
      text-align: left;
      letter-spacing: 2px;
    }

    .right-desc {
      display: flex;
      justify-content: space-between;
      font-size: 16px;

      .red-font {
        border: 1px solid red;
        border-radius: 3px;
        color: red;
        font-weight: 700;
        margin-right: 10px;
        font-size: 12px;
        padding: 2px;
      }

      .hui-font {
        padding: 2px;
        background-color: #e7e7e7;
        font-size: 12px;
        color: #111111;
      }

      .hui-time {
        color: #bbbbbb;
        font-size: 16px;
        padding-right: 10px;
      }
    }

    .font-desc {
      color: #111111;
      letter-spacing: 1px;
      line-height: 27px;
      text-indent: 2em;
      text-align: left;
      .lang-en & {
        font-size: 14px;
        line-height: 1.6;
      }
    }

    .bgc-hui {
      height: 3px;
      background-color: #e6e6e6;

      .red-animation {
        height: 3px;
        width: 100px;
        background-color: red;
        transition: width 1s ease;
      }

      @media (max-width: 768px) {
        display: none;
      }
    }

    .red-href {
      position: absolute;
      bottom: 5px;
      right: 0;

      a {
        color: red;
        text-decoration: none;
        font-weight: 700;
        font-size: 15px;

        @media (max-width: 768px) {
          font-size: 10px;
        }
      }

      @media (max-width: 768px) {
        bottom: -5px;
      }
    }
  }
}
</style>
